import { cn } from '@/lib/utils'

type StatusDotVariant = 'success' | 'destructive' | 'warning'

const variantStyles: Record<StatusDotVariant, { ring: string; dot: string }> = {
  success: { ring: 'bg-success/25', dot: 'bg-success' },
  destructive: { ring: 'bg-destructive/25', dot: 'bg-destructive' },
  warning: { ring: 'bg-warning/25', dot: 'bg-warning' },
}

export interface StatusDotProps {
  variant: StatusDotVariant
  className?: string
}

export function StatusDot({ variant, className }: StatusDotProps): React.ReactElement {
  const styles = variantStyles[variant]

  return (
    <div
      className={cn(
        'flex size-5 shrink-0 items-center justify-center rounded-full',
        styles.ring,
        className,
      )}
    >
      <div className={cn('size-3 rounded-full', styles.dot)} />
    </div>
  )
}
